import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/* eslint-disable no-unused-vars */
import { useCallback, useContext, useState } from 'react';
import Toasts from '../components/shared/Toasts';
import { STORAGE } from '../constants';
import FreePdf from '../services/FreePdf';
import { startSession } from '../store';
import EditorContext from '../store/Editor.context';
import { bytesToSize, fileToBase64 } from '../utils/helpers';
import { getDocument } from 'pdfjs-dist/build/pdf';
import { setPdfWorker } from '../utils/helpers';
import PdfjsWorker from 'pdfjs-dist/build/pdf.worker';
setPdfWorker(PdfjsWorker);

var useLoadPdf = function useLoadPdf(_ref) {
  var onLoadSuccess = _ref.onLoadSuccess,
      onLoadError = _ref.onLoadError,
      _ref$maxSizeFile = _ref.maxSizeFile,
      maxSizeFile = _ref$maxSizeFile === void 0 ? 1024 * 1024 * 5 : _ref$maxSizeFile,
      _ref$maxNumberPages = _ref.maxNumberPages,
      maxNumberPages = _ref$maxNumberPages === void 0 ? 100 : _ref$maxNumberPages;

  var _useContext = useContext(EditorContext),
      dispatch = _useContext.dispatch;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(false),
      loaded = _useState2[0],
      setLoaded = _useState2[1];

  var handleLoad = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file) {
      var _window$Intercom, _window, base64, pdfDocument, intercomId, data;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return fileToBase64(file);

            case 4:
              base64 = _context.sent;

              if (!((file === null || file === void 0 ? void 0 : file.size) > maxSizeFile)) {
                _context.next = 7;
                break;
              }

              throw new Error("File size should be not more than " + bytesToSize(maxSizeFile));

            case 7:
              _context.next = 9;
              return getDocument({
                url: base64
              });

            case 9:
              pdfDocument = _context.sent;

              if (!(pdfDocument.numPages > maxNumberPages)) {
                _context.next = 12;
                break;
              }

              throw new Error("PDF must be less than than " + maxNumberPages + " pages");

            case 12:
              setLoading('Preparing your file for secure redaction...');
              localStorage.clear();
              intercomId = (_window$Intercom = (_window = window).Intercom) === null || _window$Intercom === void 0 ? void 0 : _window$Intercom.call(_window, 'getVisitorId');
              _context.next = 17;
              return FreePdf.startSession(intercomId);

            case 17:
              data = _context.sent;
              FreePdf.setAuthToken(data.authToken);
              _context.next = 21;
              return FreePdf.uploadToS3({
                signedUrl: data.PutUrl,
                file: file
              });

            case 21:
              localStorage.setItem(STORAGE.authToken, data.authToken);
              localStorage.setItem(STORAGE.uploadedFile, base64);
              localStorage.setItem(STORAGE.isOpenTour, true);
              dispatch(startSession({
                uploadedPdfDocument: pdfDocument
              }));
              setLoaded(true);
              if (onLoadSuccess) onLoadSuccess();
              _context.next = 33;
              break;

            case 29:
              _context.prev = 29;
              _context.t0 = _context["catch"](0);
              Toasts.error({
                description: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message
              });
              if (onLoadError) onLoadError();

            case 33:
              _context.prev = 33;
              setLoading(false);
              return _context.finish(33);

            case 36:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 29, 33, 36]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  return {
    load: handleLoad,
    loading: loading,
    loaded: loaded
  };
};

export default useLoadPdf;